export default "__VITE_ASSET__BFzilHG2__"